module.exports = __webpack_public_path__ + "img/BG_Cutout.2d399a7c.svg";